<template>
  <div class="mystudent">
    <div class="title">
      <h2>班级详情</h2>
      <p class="back" @click="tomyClass">
        <img src="../../assets/mine/back.png" alt="">
        返回
      </p>
    </div>
    <div class="nav">
      <p class="manname">班级名称：{{classtitle}}</p>
      <p class="mandel">
        <img class="manteaimg" src="../../assets/mine/myclassteacher.png" alt="">
        <span class="mantea">班级教师：{{teacher}}</span>
        <img  class="mannumimg" src="../../assets/mine/myclassnum.png" alt="">
        <span class="mannum">班级人数：{{studentNum}}</span>
        <img  class="mansubimg" src="../../assets/mine/myclasssub.png" alt="">
        <span class="mansub" :title="this.title">所属课程：{{title}}</span>
        <span class="tostudy" @click="tostudy">去学习></span>
      </p>
    </div>
    <div class="tit">
        班级同学
    </div>
    <div class="box">
      <ul class="list">
        <li v-for="(item) in list" :key="item.id">
          <img
            src="../../assets/mine/myclassstudent.png"
            alt=""
          >
          <p>{{item.realname}}</p>
        </li>
      
      </ul>
    </div>
  </div>
</template>

<script>
import { getclassmateApi } from "@/request/api";
export default {
  name: "mystudent",
  data() {
    return {
      classId: "",
      list: [],
      classtitle:'',
      title:'',
      teacher:'',
      courseId:'',
      studentNum:''
    };
  },
  created() {
    this.classId = this.$route.query.id;
    this.init();
  },
  methods: {
    init() {
      this.getToken(getclassmateApi, { classId: this.classId }, (res) => {
        this.list = res.data.Student;
        this.teacher=res.data.teacher.realname
        this.classtitle=res.data.title
        this.courseId=res.data.course.id
        this.title=res.data.course.title
        this.studentNum=res.data.studentNum
        // console.log(this.list)
      });
    },
    tomyClass() {
      this.$router.push({ path: "/myClass" });
    },
    tostudy(){
      // console.log("去学习")
      this.$router.push({path:'/courseInfo',query:{id:this.$Base64.encode(this.courseId)}})
    }
  },
};
</script>
<style>
.empty {
  margin: 0 auto;
  margin-top: 30px;
}
</style>
<style lang="stylus" scoped>
.mystudent {
  margin-bottom: 100px;
  .title {
      height: 45px;
      line-height: 45px;
      overflow: hidden;
      border-bottom:1px solid #eff2f2;
      display:flex;
      align-items center;
      justify-content space-between;
    h2 {
      margin-left: 30px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      margin-bottom:0px;
    }
    .back {
      color: #4281ff;
      width: 50px;
      font-size:14px;
      margin-right:20px;
      cursor: pointer;
      margin-bottom:0px;
      img{
        width:15px;
        height:15px;
        margin-top:-3px;
      }
    }

    span {
      color: #f1ce48;
      border: 1px solid #eee;
      width: 50px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      position: absolute;
      right: 30px;
      top: 50%;
      cursor: pointer;
      transform: translateY(-50%);
    }
  }

  .nav {
    // height: 70px;
    margin-top: 30px;
    margin-left: 30px;
    margin-right: 30px;
    .manname{
      color: #c56b2f;
      font-size:18px;
      margin-bottom:20px;
    }
    .mandel{
      margin-bottom:0px;
      font-size: 16px;
      display:flex;
      // align-items center;
      color:#333;
      img{
          width:20px;
          height:20px;
      }
      .mannumimg{
         margin-left:50px;
      }
      .mansubimg{
          margin-left:50px;
      }
      .mantea{
        margin-left:13px;
      }
      .mannum{
        margin-left:11px;
      }
      .mansub{
        margin-left:11px;
        max-width:400px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .tostudy{
        margin-left:30px;
        color: #4281ff;
        cursor pointer;
        font-size:14px;
      }
    }
  }
  .tit {
    height: 20px;
    line-height: 20px;
    margin-top: 30px;
    margin-left:30px;
    font-size: 16px;
    color: #333;
    }
  .box {
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 15px;
    border: solid 1px #e6e6e6;
    .list {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      li {
        display: flex;
        height: 61px;
        align-items: center;
        width: 185px;
        font-size:14px;
        color:#333;
        justify-content: center;
       
        img {
          width: 35px;
          height: 35px;
        }

        p {
          color: #333;
          font-size: 16px;
          margin-left: 15px;
          margin-bottom: 0px;
        }
      }
      li:nth-child(5n) {
        margin-right: 0px;
      }
    }
  }
}
</style>
